module.exports = __webpack_public_path__ + "img/chevron-left.40e832f0.svg";